import { getInstance } from './instance';

const instance = getInstance();

export const getGhlWebsiteByDraft = (draftId) => {
  const url = `/ghl/websites/by-draft/${draftId}`;
  return instance
    .get(url)
    .then((response) => response.data)
    .catch(() => null);
};
